module.exports = __webpack_public_path__ + "static/media/logo192.b56d1a0c.png";